export type ValidAngles = '0' | '45' | '90' | '135' | '180' | '225' | '270' | '315';

export const getGradient = (angle?: ValidAngles, color1?: string, color2?: string): string => {
	if (angle && color1 && color2) {
		return `linear-gradient(${angle}deg, ${color1}, ${color2})`;
	}
	return '';
};
